module.exports = __webpack_public_path__ + "img/namibia_icc.62027f8a.png";